import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '../store';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector = <T>(selector: (state: RootState) => T): T => useSelector(selector);

export { useCopyRow } from './useCopyRow';
export { useCopyCell } from './useCopyCell';
export { useColumnResize } from './useColumnResize';
export { useReportExport } from './useReportExport';
